import { MOCK_CONFLUENCE_SMART_LINK_TEST } from './mock_confluence_smart_link_test';

// Build a collect(entity) style response from the individual Confluence entity rows.
const CONFLUENCE_NODES =
	(MOCK_CONFLUENCE_SMART_LINK_TEST as any)?.data?.graphStore?.cypherQueryV2?.edges
		?.map((edge: any) => (edge?.node?.columns as any[])?.find?.((c) => c?.key === 'entity')?.value)
		?.filter(Boolean) ?? [];

export const MOCK_CONFLUENCE_COLLECT: {
	readonly data: {
		readonly graphStore: {
			readonly cypherQueryV2: {
				readonly edges: readonly [
					{
						readonly node: {
							readonly __typename: 'GraphStoreCypherQueryV2Node';
							readonly columns: readonly [
								{
									readonly key: 'collect(entity)';
									readonly value: {
										readonly nodes: any;
									};
								},
							];
						};
					},
				];
			};
		};
	};
	readonly extensions: {
		readonly gateway: {
			readonly request_id: 'confluence-smart-link-test-request-id';
			readonly tId: 'confluence-smart-link-test-trace-id';
			readonly crossRegion: false;
			readonly edgeCrossRegion: false;
		};
	};
} = {
	data: {
		graphStore: {
			cypherQueryV2: {
				edges: [
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'collect(entity)',
									value: {
										nodes: CONFLUENCE_NODES,
									},
								},
							],
						},
					},
				],
			},
		},
	},
	extensions: MOCK_CONFLUENCE_SMART_LINK_TEST.extensions,
} as const;
